// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--3LEE3","link":"styles-module--link--37UZ7","activeLink":"styles-module--activeLink--1yfCw styles-module--link--37UZ7"};